import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        headerBar: {
            width: '100%',
            backgroundColor: 'background.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        container: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: ['center', 'center', 'center', 'flex-start'],
            maxWidth: 'container.xxl',
        },
        containerSpacing: {
            '@media (max-width: 1199px)': {
                paddingY: 'small.base',
                mx: 0,
                px: 'small.base',
                paddingBottom: remCalc(16),
                paddingTop: remCalc(16),
            },
            '@media (min-width: 1200px) and (max-width: 1399px)': {
                paddingY: 'small.lg',
                mx: 0,
                px: 'small.base',
            },
            '@media (min-width: 1400px)': {
                paddingY: remCalc(30),
                mx: 'auto',
            },
        },
        content: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
        },
        bodyContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        bodyContainerGap: {
            '@media (max-width: 1199px)': {
                gap: 0,
            },
            '@media (min-width: 1200px)': {
                gap: remCalc(30),
            },
        },
        linksAndIcons: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: remCalc(20),
        },
        iconsFlex: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        iconsFlexGap: {
            gap: {base: remCalc(32), md: remCalc(24), lg: remCalc(32)},
            '@media (min-width: 1199px)': {
                gap: remCalc(24),
            },
        },
        headerIcon: {
            '@media (max-width: 1199px)': {
                width: remCalc(24),
                height: remCalc(24),
            },
            '@media (min-width: 1200px)': {
                width: remCalc(32),
                height: remCalc(32),
            },
        },
        headerButton: {
            backgroundColor: 'background.dark',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        links: {
            textStyle: 'body-small',
            color: 'text.secondary',
            verticalAlign: 'middle',
        },
        logo: {
            '@media (max-width: 1023px)': {
                width: remCalc(86),
                height: remCalc(25),
            },
            '@media (min-width: 1024px)': {
                width: remCalc(136),
                height: remCalc(43),
            },
        },
        wishlistIcon: {
            '@media (max-width: 1199px)': {
                width: remCalc(24),
                height: remCalc(24),
                fill: 'background.default',
                color: 'background.dark',
                strokewidthnumber: remCalc(3),
            },
            '@media (min-width: 1200px)': {
                width: remCalc(32),
                height: remCalc(32),
                fill: 'background.default',
                color: 'background.dark',
                strokewidthnumber: remCalc(3),
            },
        },
        wishlistBadge: {
            top: 'auto',
            bottom: remCalc(18),
            right: remCalc(-10),
            backgroundColor: 'background.alternative',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            alignItems: 'center',
            width: remCalc(20),
            height: remCalc(20),
            p: 0,
        },
        accountIcon: {
            '@media (max-width: 1199px)': {
                width: remCalc(24),
                height: remCalc(24),
                color: 'background.dark',
            },
            '@media (min-width: 1200px)': {
                width: remCalc(32),
                height: remCalc(32),
                color: 'background.dark',
            },
        },
        cartIcon: {
            '@media (max-width: 1199px)': {
                width: remCalc(24),
                height: remCalc(24),
                color: 'background.dark',
            },
            '@media (min-width: 1200px)': {
                width: remCalc(32),
                height: remCalc(32),
                color: 'background.dark',
            },
        },
        initialsText: {
            '@media (max-width: 1199px)': {
                textStyle: 'body-xxsmall',
            },
            '@media (min-width: 1200px)': {
                textStyle: 'body-xsmall',
            },
        },
        burgerIcon: {
            width: remCalc(24),
            height: remCalc(24),
        },
        buttonIcons: {
            minWidth: '0',
            minHeight: '0',
        },
        arrowDownIcon: {
            width: [remCalc(15), remCalc(15), remCalc(15), remCalc(15)],
            height: [remCalc(16), remCalc(16), remCalc(16), remCalc(16)],
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50',
            },
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal',
        },
        signoutIcon: {
            marginRight: 2,
        },
        hideOnMobile: {
            '@media (max-width: 1199px)': {
                display: 'none',
            },
            '@media (min-width: 1200px)': {
                display: 'flex',
            },
        },
        hideOnDesktop: {
            '@media (max-width: 1199px)': {
                display: 'flex',
                gap: {base: remCalc(32), md: remCalc(24), lg: remCalc(32), xl: remCalc(24)},
            },
            '@media (min-width: 1200px)': {
                display: 'none',
            },
        },
        showOnXl: {
            '@media (max-width: 1399px)': {
                display: 'none',
            },
            '@media (min-width: 1400px)': {
                display: 'flex',
            },
        },
        showOnLgOnly: {
            '@media (max-width: 1199px)': {
                display: 'none',
            },
            '@media (min-width: 1400px)': {
                display: 'none',
            },
        },
        supportIcon: {
            fill: 'background.default',
            color: 'background.dark',
            strokewidthnumber: remCalc(3),
            boxSize: 'iconsSize.medium',
        },
        srOnly: {
            width: 0,
            height: 0,
            overflow: 'hidden',
            position: 'absolute',
            zIndex: -1,
        },
    },
    variants: {
        checkout: {
            headerBar: {
                width: '100%',
                backgroundColor: 'background.default',
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingX: {
                    base: remCalc(16),
                    md: remCalc(24),
                    lg: remCalc(24),
                    xl: remCalc(0),
                },
            },
            headerBarSpacing: {
                '@media (min-width: 1400px)': {
                    paddingX: remCalc(0),
                },
            },
            containerSpacing: {
                '@media (max-width: 768px)': {
                    paddingX: {base: remCalc(0), md: remCalc(16)},
                    paddingY: 'small.base',
                    paddingBottom: remCalc(16),
                    paddingTop: remCalc(16),
                },
                '@media (min-width: 768px) and (max-width: 1199px)': {
                    paddingY: 'small.lg',
                },
                '@media (min-width: 1200px) and (max-width: 1439px)': {
                    paddingY: 'small.lg',
                },
                '@media (min-width: 1440px)': {
                    paddingY: remCalc(30),
                    paddingX: {base: remCalc(40), xl: remCalc(0)},
                },
            },
        },
        kenwood: {
            iconsFlex: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: remCalc(24),
            },
        },
    },

    parts: [
        'container',
        'content',
        'searchContainer',
        'bodyContainer',
        'buttonIcons',
        'logo',
        'icons',
        'signout',
        'headerBar',
        'headerBarSpacing',
        'containerSpacing',
        'wishlistIcon',
        'wishlistBadge',
        'accountIcon',
        'initialsText',
        'iconsFlex',
    ],
}
